import { createPaginatedSlice } from "../../helpers/reduxHelper";

const textures = createPaginatedSlice('textures');

export const texturesActions = textures.actions
export const texturesSelector = state => state.textures;
export const texturesReducer = textures.reducer;
export default texturesReducer

export const texturesSelectors = textures.LF.selectors